import React from 'react';
import { IDeviceChannel } from 'lavva.exalushome/build/js/Services/Devices/IDeviceChannel';
import { TurnOn } from 'lavva.exalushome/build/js/Services/Devices/Tasks/Tasks';
import IconButton from '@mui/material/IconButton';
import { IconPlay } from '../../../../../../../assets/icons/icon-play';
import { useExalusServicesContext } from '../../../../../context/services';
import { useDeviceTaskExecuted } from '../../../../../modules/add-devices/hooks/use-device-task-executed';

type SwitchControlsProps = {
  channel: IDeviceChannel;
};

const SceneControls: React.FC<SwitchControlsProps> = ({ channel }) => {
  const { devicesApi } = useExalusServicesContext();
  const { handleResult } = useDeviceTaskExecuted();
  const controlVisible = !channel.IsHidden;

  const runSequence = async () => {
    const device = channel.GetDevice();

    const task = new TurnOn();
    task.Channel = channel.Number;
    task.DeviceGuid = device.Guid;

    const result = await devicesApi.ExecuteDeviceTaskAsync(device, task);

    handleResult(result, device.Name);
  };

  if (!controlVisible) return null;

  return (
    <IconButton className="action-btn" onClick={runSequence}>
      <IconPlay size={28} />
    </IconButton>
  );
};

export default SceneControls;
